import { Link, useSearchParams } from 'react-router-dom';
import SiteHeader from '../components/SiteHeader';
import SiteFooter from '../components/SiteFooter';
import '../styles/donate.css';

/**
 * Where Stripe redirects after a confirmed gift. Stripe appends
 * `redirect_status` (and the PaymentIntent) to the return_url; we read it to
 * distinguish a completed gift from one still processing.
 */
export default function DonateSuccess() {
  const [params] = useSearchParams();
  const status = params.get('redirect_status');
  const processing = status === 'processing';

  return (
    <>
      <SiteHeader active="donors" />
      <main>
        <section className="section donate">
          <div className="wrap donate-wrap">
            <div className="head">
              <div className="eyebrow">Thank you</div>
              <h2>
                {processing ? (
                  <>Your gift is <em>processing</em></>
                ) : (
                  <>Your gift is <em>received</em></>
                )}
              </h2>
            </div>
            <p data-testid="donate-success-message">
              {processing
                ? 'Your payment is being processed. We’ll email you a receipt once it settles.'
                : 'Thank you for your generosity. A receipt is on its way to your inbox.'}
            </p>
            <p>
              <Link to="/" className="btn btn-ghost" data-testid="donate-success-home-link">
                Back to home
              </Link>
            </p>
          </div>
        </section>
      </main>
      <SiteFooter />
    </>
  );
}
